import React, { useEffect, useState } from "react";

import styles from "../../App.module.css";
import stylesVisitor from "./visitor.module.css";
import api from "../../api/axios";
import { NotificationContainer } from "react-notifications";
import notifications from "../../components/notifications";

import { useClienteData } from "../../components/Clientes/ClienteData";

function ShowAgendamento(clienteIDd) {
    const clienteID = clienteIDd.clienteID; // ✅ vem da rota /home/:clienteID

    // console.log("clienteID em ShowAgendamento:", clienteID);

    const [notificationType, setNotificationType] = useState(0);
    const cliente = useClienteData(clienteID);
    const [agendamentos, setAgendamentos] = useState([]);
    const [loadingAgend, setLoadingAgend] = useState(false);
    const [verTodosAgendamentos, setVerTodosAgendamentos] = useState(false);
    // ✅ Hook 1
    useEffect(() => {
        if (notificationType && notifications[notificationType]) {
            notifications[notificationType]();
            setNotificationType(0);
        }
    }, [notificationType]);

    // ✅ Hook 2 (antes de qualquer return!)
    useEffect(() => {
        if (!clienteID) return;

        const fetchAgendamentos = async () => {
            setLoadingAgend(true);
            try {
                const res = await api.get(`/AgendamentosClient/${clienteID}`);
                // console.log("res.data")
                // console.log(res.data)
                setAgendamentos(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error("Erro ao buscar agendamentos do cliente:", err);
                setAgendamentos([]);
            } finally {
                setLoadingAgend(false);
            }
        };

        fetchAgendamentos();


    }, [clienteID]);





const formatarData = (dateLike) => {
    if (!dateLike) return "--/--/----";

    const dataSomente = dateLike.slice(0, 10); // "2026-03-03"
    const [ano, mes, dia] = dataSomente.split("-");

    return `${dia}/${mes}/${ano}`;
};

    const formatarHora = (h) => {
        if (!h) return "--:--";
        if (typeof h === "string" && h.length >= 5) return h.slice(0, 5);
        return String(h);
    };


    // ✅ AGORA SIM: returns condicionais depois de todos hooks
    if (!cliente) {
        return (
            <div className={styles.app}>
                <div className={styles.cadastroClienteContainer}>
                    <p>Carregando dados do cliente...</p>
                </div>
                <NotificationContainer />
            </div>
        );
    }


    const toDateTime = (item) => {
        // Preferência: usar `data` (datetime completo) se vier
        if (item?.data) {
            
            const d = new Date(item.data);
            if (!Number.isNaN(d.getTime())) return d;
        }

        // Fallback: junta dataDia + dataHorario
        const dia = item?.dataDia ? new Date(item.dataDia) : null;
        if (!dia || Number.isNaN(dia.getTime())) return null;

        const horario = (item?.dataHorario || "00:00:00").slice(0, 8);
        const [hh, mm, ss] = horario.split(":").map((n) => parseInt(n, 10) || 0);

        const d = new Date(dia);
        d.setHours(hh, mm, ss, 0);
        return d;
    };


    // normaliza + ordena crescente (mais próximo primeiro)
    const agendamentosOrdenados = (Array.isArray(agendamentos) ? agendamentos : [])
        .map((a) => ({ ...a, __dt: toDateTime(a) }))
        .filter((a) => a.__dt && !Number.isNaN(a.__dt.getTime()))
        .sort((a, b) => a.__dt - b.__dt);

    // só futuros (próximos)
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0); // Define o início do dia de hoje

    const proximosAgendamentos = agendamentosOrdenados.filter((a) => a.__dt >= hoje);

    // quantos mostrar no preview (ajuste aqui)
    const LIMITE_PREVIEW = 2;

    const agendamentosParaMostrar = verTodosAgendamentos
        ? agendamentosOrdenados
        : proximosAgendamentos.slice(0, LIMITE_PREVIEW);


    const isAgendamentoPassado = (ag) => {
        // Usa o datetime completo se existir
        if (ag?.data) {
            const d = new Date(ag.data);
            return d < new Date();
        }

        // Fallback: junta dataDia + dataHorario
        if (ag?.dataDia && ag?.dataHorario) {
            const dia = new Date(ag.dataDia);
            const [hh, mm, ss] = ag.dataHorario.split(":").map(Number);
            dia.setHours(hh || 0, mm || 0, ss || 0, 0);
            return dia < new Date();
        }

        return false;
    };





    return (
        <div
            className={styles.cadastroItems06}
            style={{
                paddingBlock: "20px", borderRadius: "20px",
                // backgroundColor: "white",
                marginBlock: "10px", maxWidth: "600px", textAlign: "center"
            }}
        >

            <div style={{ width: "100%" }} >
                {/* Appointment título */}
                <div className={stylesVisitor.clientePageSectionTitle}>
                    <span className={stylesVisitor.clientePageSectionLeft}>Agendamentos</span>
                    <button
                        type="button"
                        className={stylesVisitor.clientePageSectionRight}
                        onClick={() => setVerTodosAgendamentos((v) => !v)}
                        style={{ background: "transparent", border: "none", cursor: "pointer" }}
                    >
                        {verTodosAgendamentos ? "Mostrar próximos" : "Ver agendamentos antigos"}
                    </button>
                </div>
                {/* ✅ Lista de cards dinâmica */}
                {loadingAgend ? (
                    <div className={stylesVisitor.clientePageAppointmentCard}>
                        <div className={stylesVisitor.clientePageAppointmentLeft}>
                            <div className={stylesVisitor.clientePageAppointmentInfo}>
                                <span className={stylesVisitor.clientePageAppointmentInfoSmall}>Carregando...</span>
                                <span className={stylesVisitor.clientePageAppointmentInfoTitle}>AGUARDE</span>
                            </div>
                        </div>
                        <div className={stylesVisitor.clientePageAppointmentHour}>--:--</div>
                    </div>
                ) : agendamentosOrdenados.length === 0 ? (
                    <div className={stylesVisitor.clientePageAppointmentCard}>
                                <span style={{ color: "black" }} className={stylesVisitor.clientePageAppointmentInfoTitle}>
                                    Nenhum agendamento feito
                                </span>

                        <div className={stylesVisitor.clientePageAppointmentHour}>--:--</div>
                    </div>
                ) : agendamentosParaMostrar.length === 0 ? (
                    // tem histórico, mas não tem próximos
                    <></>
                    /* <div className={stylesVisitor.clientePageAppointmentCard}>
                        Nenhum agendamento encontrado
                    </div> */
                ) : (


                    agendamentosParaMostrar.map((ag) => {
                        const passado = isAgendamentoPassado(ag);
                        const responsavel = ag.responsavelNome || "Não informado";

                        console.log("Agendamento:", ag);
                        console.log("Data:", formatarData(ag.dataDia));

                        return (
                            <div
                                key={ag.id}
                                style={{
                                    // width: "100%",
                                    background: passado
                                        ? "linear-gradient(180deg, #7a7a7a 0%, #5e5e5e 100%)"
                                        : "linear-gradient(180deg, #2f7bff 0%, #1f66ff 100%)",
                                    borderRadius: 18,
                                    padding: 16,
                                    marginTop: 12,
                                    color: "#fff",
                                    fontFamily: "Arial, Helvetica, sans-serif",
                                    boxShadow: passado
                                        ? "0 10px 22px rgba(0,0,0,0.18)"
                                        : "0 14px 30px rgba(18, 63, 160, 0.25)",
                                    position: "relative",
                                    overflow: "hidden",
                                    opacity: passado ? 0.9 : 1,
                                }}
                            >
                                {/* TOP */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: 12,
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                        {/* Avatar (pode trocar por foto do responsável se tiver) */}
                                        <div
                                            style={{
                                                width: 44,
                                                height: 44,
                                                borderRadius: "50%",
                                                background: "rgba(255,255,255,0.2)",
                                                border: "2px solid rgba(255,255,255,0.35)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: 18,
                                                flex: "0 0 auto",
                                            }}
                                            title={responsavel}
                                        >
                                            <img
                                                src={
                                                    ag.tipo === 'analise de perfil' || ag.tipo === 're-analise'
                                                        ? '/icons/detective.svg'
                                                        : ag.tipo === 'reversao de negativa' || ag.tipo === 'treinamento'
                                                        ? '/icons/manager.svg'
                                                        : '/icons/manager.svg'
                                                }
                                                alt="Icone"
                                                style={{ width: 44, height: 44 }}
                                            />
                                        </div>

                                        {/* Título e subtítulo */}
                                        <div style={{ lineHeight: 1.15 }}>
                                            <div style={{ fontWeight: 800, fontSize: 16, letterSpacing: 0.1 }}>
                                                {ag.tipo?.toUpperCase()}
                                            </div>
                                            <div style={{ fontSize: 14, opacity: 0.85, marginTop: 4, textAlign: "left" }}>
                                                Responsável: {responsavel}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Botão direita */}
                                    {ag.meetLink ? (
                                        <a
                                            href={ag.meetLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                background: "#fff",
                                                color: "var(--corPrimaria)",
                                                borderRadius: 10,
                                                padding: "8px 10px",
                                                fontWeight: 800,
                                                lineHeight: 1,
                                                textDecoration: "none",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 8,
                                                border: "1px solid rgba(255,255,255,0.35)",
                                            }}
                                        >
                                            <img
                                                src="/meetLogo.png"
                                                alt="Google Meet"
                                                style={{ width: 18, height: 18, display: "block" }}
                                            />
                                            Entrar
                                        </a>

                                    ) : (
                                        <div
                                            style={{
                                                width: 44,
                                                height: 44,
                                                borderRadius: 14,
                                                background: "rgba(255,255,255,0.14)",
                                                border: "1px solid rgba(255,255,255,0.18)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: 18,
                                                opacity: 0.9,
                                            }}
                                            title="Sem link de chamada"
                                        >
                                            —
                                        </div>
                                    )}
                                </div>

                                {/* Divider */}
                                <div
                                    style={{
                                        height: 1,
                                        background: "rgba(255,255,255,0.18)",
                                        margin: "14px 0 12px",
                                    }}
                                />

                                {/* Bottom: Observação */}
                                {ag.observacoes && (
                                    <span style={{ fontSize: "14px", color: "#fff", opacity: 0.8, marginBottom: 12, display: "block" }}>
                                        {ag.observacoes}
                                    </span>
                                )}

                                {/* Bottom: data e hora */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 14,
                                        flexWrap: "wrap",
                                        fontSize: 16,
                                        opacity: 0.95,
                                        justifyContent: "center",
                                        backgroundColor: "rgba(0, 0, 0, 0.34)",
                                        padding: "8px 12px",
                                        borderRadius: 12,

                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span style={{ fontSize: 15 }}>📅</span>
                                        <span>{formatarData(ag.dataDia)}</span> 
                                    </div>

                                    <div
                                        style={{
                                            width: 1,
                                            height: 14,
                                            background: "rgba(255,255,255,0.25)",
                                            margin: "0 2px",
                                        }}
                                    />

                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span style={{ fontSize: 15 }}>⏰</span>
                                        <span>{formatarHora(ag.dataHorario)}</span>
                                    </div>


                                </div>

                                {/* Círculo decorativo */}
                                <div
                                    style={{
                                        position: "absolute",
                                        right: -60,
                                        top: -60,
                                        width: 180,
                                        height: 180,
                                        background: "rgba(255,255,255,0.12)",
                                        borderRadius: "50%",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        );
                    })






                )}






            </div>
            <NotificationContainer />
        </div>
    );
}

export default ShowAgendamento;
